import * as ActionConfigurationManager from './config.actions';

export const loadRegistrationState = ActionConfigurationManager.SAVE_REGISTRATION_STATE;
export const updateRegistration = ActionConfigurationManager.UPDATE_REGISTRATION;
export const rehydrateRegistration = ActionConfigurationManager.REHYDRATE_REGISTRATION;
export const clearRegistration = ActionConfigurationManager.CLEAR_REGISTRATION
